import React from "react";
import appstore from "./assets/images/appstore.png";
import playstore from "./assets/images/playstore.png";
import dwelioIcon from "./assets/images/logo.png";

const DownloadPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #0059b3, #00ccff)",
        color: "white",
        fontFamily: "'Poppins', sans-serif",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 40,
        textAlign: "center",
      }}
    >
      <img
        src={dwelioIcon}
        alt="Dwelio Logo"
        style={{
          width: 220,
          height: "auto",
          marginBottom: 30,
          filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))", // optional subtle shadow
        }}
      />
      <h1 style={{ fontSize: 48, fontWeight: 600, marginBottom: 20 }}>
        Download the App
      </h1>

      <p style={{ fontSize: 20, marginBottom: 50 }}>
        Get the latest version for your device on iOS or Android.
      </p>

      <div
        style={{
          display: "flex",
          gap: 40,
          flexWrap: "wrap",
          justifyContent: "center",
          maxWidth: 400,
          width: "100%",
        }}
      >
        <a
          href="https://testflight.apple.com/join/TM1cmeSW"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "block",
            width: 160,
            boxShadow: "0 0px 0px rgba(0,0,0,0.3)",
            borderRadius: 12,
            overflow: "hidden",
          }}
        >
          <img
            src={appstore}
            alt="Download on the App Store"
            style={{ width: "100%", height: "auto" }}
          />
        </a>

        <a
          href="https://play.google.com/apps/testing/com.dwelio"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "block",
            width: 160,
            boxShadow: "0 0px 0px rgba(0,0,0,0.3)",
            borderRadius: 12,
            overflow: "hidden",
          }}
        >
          <img
            src={playstore}
            alt="Get it on Google Play"
            style={{ width: "100%", height: "auto" }}
          />
        </a>
      </div>

      <p
        style={{
          marginTop: 60,
          fontSize: 14,
          color: "rgba(255,255,255,0.7)",
          maxWidth: 320,
          lineHeight: 1.4,
        }}
      >
        By downloading, you agree to our{" "}
        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#cce7ff", textDecoration: "underline" }}
        >
          Terms and Conditions
        </a>{" "}
        and{" "}
        <a
          href="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#cce7ff", textDecoration: "underline" }}
        >
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );
};

export default DownloadPage;
